const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the oauth transition Directive which defines the sign in form behavior and markup
 * @argument {Users} Users injected to access the Users resource
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('oauthTransition', ['Application', 'Authorization', 'Analyze', 'AuthorizationResource', '$translate', 'i18n', '$location', function (Application, Authorization, Analyze, AuthorizationResource, $translate, i18n, $location) {
  return {
    restrict: 'E',
    template: require('../../../templates/directives/preauth/oauth-transition.html'),
    controller: async function () {

      if (Application.navigation.getPath() !== '/oauth-transition') {
        return;
      }
      var self = this;
      Authorization.signout(true);

      var params = Application.navigation.getUrlParameters();

      // The query carries a sign-in key and usually the user's email. Every way out of this page
      // clears the query and replaces this history entry, so neither is left in browser history.
      // The key names its user, so a landing may carry it without the identifier.
      if (params.key) {

        self.loading = true;

        // In the body, not the URL: the api's access log records query strings, and the identifier
        // is usually the user's email.
        var handoff = {key: params.key};
        if (params.identifier) {
          handoff.identifier = params.identifier;
        }

        AuthorizationResource.oauth({}, handoff, async function(data) {
          if (Authorization.validateAndUseAuthToken(data)) {
            self.loading = false;
            Authorization.setActive();
            Analyze.record({resource: 'useragents'}, {useragent: Application.userAgent});
            Analyze.record({resource: 'authtokens'}, {token: Authorization.getAuthToken().token, action: 'signin'});
            Application.analyticsProvider.trackEvent('signin');
            var redirectPath = Application.storage.get('preRedirect');
            var redirectParamsLogin = Application.storage.get('redirectParams') || {};
            Application.storage.remove('redirectParams');
            var redirect = {};
            if (redirectParamsLogin.integration) {
              redirect.integration = redirectParamsLogin.integration;
            }
            // LANGUAGE
            if (Authorization.getAuthToken() && Authorization.getAuthToken().user && Authorization.getAuthToken().user.language) {
              i18n.language(Authorization.getAuthToken().user.language);
            }

            $location.replace();
            if (redirectPath) {
              Application.storage.remove('preRedirect');
              Application.navigation.goTo(redirectPath, redirect);
              return;
            }
            Application.navigation.goToHome();
            return;
          }
          $location.replace();
          Application.navigation.goTo('/signin', {});
        }, async function() {
          self.loading = false;
          Authorization.clearAuthToken();
          // Leave before the await: a $location change after a native await happens outside the digest.
          $location.replace();
          Application.navigation.goTo('/signin', {});
          self.translations = await $translate(['modules.notifications.invalidCredentials']);
          Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.invalidCredentials'], duration: 5});
          Application.notifications.setError(self.translations['modules.notifications.invalidCredentials']);
        });

      } else {
        // A landing without a key can't sign in, and may still carry the identifier.
        $location.replace();
        Application.navigation.goTo('/signin', {});
        self.translations = await $translate(['modules.notifications.invalidCredentials']);
        Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.invalidCredentials'], duration: 5});
        Authorization.clearAuthToken();
        Application.notifications.setError(self.translations['modules.notifications.invalidCredentials']);
      }

    },
    controllerAs: 'oauth'
  };
}]);
